
import { CommonModule } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { StepConfig, STEPS } from '@app/shared/utils/stepper.config';
import { filter, Subject, takeUntil } from 'rxjs';


@Component({
  selector: 'app-stepper',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent implements OnInit, OnDestroy {
  @Input({ required: false }) steps: StepConfig[] = STEPS;

   /** 👇 Add this line to fix the error and make it configurable */
  @Input({ required: false }) hideOnRoutes: string[] = ['/eclaim','/claim-completion'];

  currentIndex = 0;
  private destroy$ = new Subject<void>();

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.updateCurrentIndex(this.router.url);
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd), takeUntil(this.destroy$))
      .subscribe((e: any) => this.updateCurrentIndex(e.urlAfterRedirects));
  }

  private updateCurrentIndex(url: string) {
    const pathOnly = (url || '').split('?')[0];
    const idx = this.steps.findIndex(s => 
      Array.isArray(s.path) ? s.path.includes(pathOnly) : s.path === pathOnly
    );
    this.currentIndex = idx >= 0 ? idx : 0;
  }

  statusOf(i: number): 'completed' | 'active' | 'pending' {
    if (i < this.currentIndex) return 'completed';
    if (i === this.currentIndex) return 'active';
    return 'pending';
  }

  canNavigateTo(i: number): boolean {
    return i <= this.currentIndex; // allow going back only
  }

  goTo(i: number) {
    if (this.canNavigateTo(i)) {
      const targetPath = this.steps[i].path;
      // If path is an array, navigate to the first one; otherwise use the string path
      const pathToNavigate = Array.isArray(targetPath) ? targetPath[0] : targetPath;
      // this.router.navigate([pathToNavigate]);
    }
  }

  
// In stepper.component.ts
showStepper(): boolean {
  const url = this.router.url || '';
  const pathOnly = this.normalizePath(url);
  // Hide when current path matches any configured routes
  return !this.hideOnRoutes.includes(pathOnly);
}

// Helper: strip query string and fragment for consistent comparisons
private normalizePath(url: string): string {
  // Handles `/path`, `/path?x=1`, `/path#frag`, and hash-based variations
  const raw = url || '';

  // If your app uses hash routing and you ever see patterns like '/#/eclaim-top'
  // normalize it back to '/eclaim-top'.
  const hashIndex = raw.indexOf('#/');
  if (hashIndex >= 0) {
    const afterHash = raw.slice(hashIndex + 1); // '#/eclaim-top?x=1' -> '/eclaim-top?x=1'
    return afterHash.split('?')[0].split('#')[0];
  }

  return raw.split('?')[0].split('#')[0];
}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
